module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_users":"Add Users","sel_users":"Select Users"},"fr":{"add_users":"Ajouter des utilisateurs","sel_users":"Sélectionnez les utilisateurs"},"sw":{"add_users":"Ongeza Watumiaji","sel_users":"Chagua Watumiaji"}}')
  delete Component.options._Ctor
}
